import { DialogElem, DialogsState } from './types';

export const dialogsStateSelector = (state: any): DialogsState => state.dialogs;
export const currentDialogSelector = (state: any): DialogElem | undefined =>
  dialogsStateSelector(state).dialogs[0];
